import { bootstrap } from 'angular';
import app from './app/app.module';

const langs = require('../../../langs.json');
for (let lang of langs) {
   if (lang.code != 'en') {
      require(`./po/${lang.code}`);
   }
}

import './assets/styles/main';
import './self-reg-ext';

bootstrap(document, [app.name], { strictDi: true });
